module.exports = __webpack_public_path__ + "572c663aeafed41c38a84d85f7705476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/7.jpg
// module id = 290
// module chunks = 0